/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import React, { Fragment } from 'react';
import { createLogic } from 'redux-logic';

import { addToast } from 'state/toast/ToastActions';
import { ERROR_AVAILABLE_FUNDS } from 'state/preferences/PreferencesActions';

const FailedExchangeAccounts = createLogic({
  type: ERROR_AVAILABLE_FUNDS,

  // eslint-disable-next-line no-unused-vars
  process({ action }, dispatch, done) {
    // dispatch user message
    const title = '';
    const message = () => {
      return (
        <Fragment>
          Unfortunately we were unable able to retrieve the available dividend
          and capital gains options.
        </Fragment>
      );
    };

    dispatch(addToast(false, title, message));

    done();
  }
});

export default FailedExchangeAccounts;
